import { DtoBase, ValueEncoder } from "../Utils";



export class TftpSettings extends DtoBase {

	public static readonly DEFAULT_TFTP_PORT = 69;
	public static readonly DEFAULT_FILE_WAIT_TIMEOUT = 120; // in seconds

	public ServerAddress: string;
	public ServerPort: number;
	public TargetFolder: string;
	public TargetDir: string;
	public FileNameFormat: string;
	public FileWaitTimeout: number;
	public RequireAuth: boolean;
	public UserName: string;
	public Password: string;


	constructor() {
		super();

		this._Init();
	}

	private _Init(): void {
		this.ServerAddress = "";
		this.ServerPort = TftpSettings.DEFAULT_TFTP_PORT;
		this.TargetFolder = "";
		this.TargetDir = "";
		this.FileNameFormat = "";
		this.FileWaitTimeout = TftpSettings.DEFAULT_FILE_WAIT_TIMEOUT;
		this.RequireAuth = false;
		this.UserName = "";
		this.Password = "";
	}

	public Clear(): void {
		super.ClearPersistenceProps();

		this._Init();
	}

	public get HasServerAddress(): boolean {
		return !!this.ServerAddress;
	}

	public get HasServerPort(): boolean {
		return (this.ServerPort > 0);
	}

	public get HasTargetFolder(): boolean {
		return !!this.TargetFolder;
	}

	public get HasTargetDir(): boolean {
		return !!this.TargetDir;
	}

	public get HasFileNameFormat(): boolean {
		return !!this.FileNameFormat;
	}

	public get HasFileWaitTimeout(): boolean {
		return (this.FileWaitTimeout >= 0);
	}

	public get HasUserName(): boolean {
		return !!this.UserName;
	}

	public get HasPassword(): boolean {
		return !!this.Password;
	}

	public Copy(other: TftpSettings): void {
		if (!!other && (other !== this)) {
			this.ServerAddress = other.ServerAddress;
			this.ServerPort = other.ServerPort;
			this.TargetFolder = other.TargetFolder;
			this.TargetDir = other.TargetDir;
			this.FileNameFormat = other.FileNameFormat;
			this.FileWaitTimeout = other.FileWaitTimeout;
			this.RequireAuth = other.RequireAuth;
			this.UserName = other.UserName;
			this.Password = other.Password;
		}
	}

	public get IsEmpty(): boolean {
		if (this.HasServerAddress)
			return false;
		if (this.ServerPort != TftpSettings.DEFAULT_TFTP_PORT)
			return false;
		if (this.HasTargetFolder)
			return false;
		if (this.HasTargetDir)
			return false;
		if (this.HasFileNameFormat)
			return false;
		if (this.FileWaitTimeout != TftpSettings.DEFAULT_FILE_WAIT_TIMEOUT)
			return false;
		if (this.RequireAuth)
			return false;
		if (this.HasUserName)
			return false;
		if (this.HasPassword)
			return false;

		return true;
	}

	public get IsValid(): boolean {
		if (!this.HasServerAddress)
			return false;

		return true;
	}

	public Write(obj: any, context: any): void {

		obj.tftp_settings = {};
		obj = obj.tftp_settings;

		super.Write(obj, context);

		if (this.HasServerAddress) {
			obj.server_address = this.ServerAddress;
		}
		if (this.HasServerPort) {
			obj.server_port = ValueEncoder.EncodeInteger(this.ServerPort);
		}
		if (this.HasTargetFolder) {
			obj.target_folder = this.TargetFolder;
		}
		if (this.HasTargetDir) {
			obj.target_dir = this.TargetDir;
		}
		if (this.HasFileNameFormat) {
			obj.filename_format = this.FileNameFormat;
		}
		if (this.HasFileWaitTimeout) {
			obj.file_wait_timeout = ValueEncoder.EncodeInteger(this.FileWaitTimeout);
		}
		obj.requires_auth = ValueEncoder.EncodeBoolean(this.RequireAuth);
		if (this.HasUserName) {
			obj.user_name = this.UserName;
		}
		if (this.HasPassword) {
			obj.password = this.Password;
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.tftp_settings)
			throw new Error();
		obj = obj.tftp_settings;

		super.Read(obj, context);

		if (obj.server_address !== undefined) {
			this.ServerAddress = obj.server_address;
		}
		if (obj.server_port !== undefined) {
			this.ServerPort = ValueEncoder.DecodeInteger(obj.server_port);
		}
		if (obj.target_folder !== undefined) {
			this.TargetFolder = obj.target_folder;
		}
		if (obj.target_dir !== undefined) {
			this.TargetDir = obj.target_dir;
		}
		if (obj.filename_format !== undefined) {
			this.FileNameFormat = obj.filename_format;
		}
		if (obj.file_wait_timeout !== undefined) {
			this.FileWaitTimeout = ValueEncoder.DecodeInteger(obj.file_wait_timeout);
		}
		if (obj.requires_auth !== undefined) {
			this.RequireAuth = ValueEncoder.DecodeBoolean(obj.requires_auth);
		}
		if (obj.user_name !== undefined) {
			//this.UserName = obj.user_name;
			this.UserName = "";
		}
		if (obj.password !== undefined) {
			//this.Password = obj.password;
			this.Password = "";
		}
	}

}